import { render, staticRenderFns } from "./BindsStep.vue?vue&type=template&id=02d2eb64&"
import script from "./BindsStep.vue?vue&type=script&lang=js&"
export * from "./BindsStep.vue?vue&type=script&lang=js&"
import style0 from "./BindsStep.vue?vue&type=style&index=0&id=02d2eb64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports